import * as angular from 'angular';
import {IController, ITimeoutService} from "angular";
import * as _ from "lodash";
import {SplitService} from "../../../commons/services/split-service.service";
import {CommonsDialogService} from "../../../commons/services/commons-dialog.service";
import {CommonsService} from "../../../commons/services/commons-service.service";
import {ViewSettingsModel} from "../../../commons/models/view-settings.model";

export class DeliveriesTableViewCtrl implements IController {

  private deliveriesViewCtrl: any;
  private isScrollable: any;
  private pushesTimeoutRef: any;
  private maxUserIdleTimeMinutes: number;
  private viewTableSettings: ViewSettingsModel;
  public isStillThereConfirmEnabled: boolean = false;

  /* @ngInject */
  constructor(private $mdMedia, private commonsDialogService: CommonsDialogService, private $timeout: ITimeoutService, private $scope,
             private splitService: SplitService, private commonsService: CommonsService) {
    this.maxUserIdleTimeMinutes = this.splitService.maxUserIdleTimeMinutes();
  }

  $onInit() {
    this._initPushesTimer();

    if (!!this.viewTableSettings) {
      this.deliveriesViewCtrl.viewTableSettings = this.viewTableSettings;

      if (this.deliveriesViewCtrl.filterConfig.deliveriesSettings.columns &&
        _.isEqual(_.size(this.deliveriesViewCtrl.filterConfig.deliveriesSettings.columns), _.size(this.viewTableSettings.settings))) {
        this.deliveriesViewCtrl.filterConfig.deliveriesSettings.columns = this.viewTableSettings.settings;
      }
    }


    // Bind User Event Listeners
    this.commonsService.bindUserEvents((event) => {
      if (!!this.pushesTimeoutRef) {
        this._initPushesTimer();
      }
    })

    // $onDestroy Helper
    this.$scope.$on('$destroy', (scope) => {
      if (_.get(scope, 'currentScope.$ctrl.pushesTimeoutRef')) {
        scope.currentScope.$ctrl.$timeout.cancel(scope.currentScope.$ctrl.pushesTimeoutRef);
        scope.currentScope.$ctrl.pushesTimeoutRef = undefined;
      }
    })

  }

  $doCheck() {
    const availableColumns = _.pickBy(_.get(this.deliveriesViewCtrl, 'filterConfig.deliveriesSettings.columns'), (value, key) => {
      return value;
    })
    const dynamicColumns = _.pickBy(_.get(this.deliveriesViewCtrl, 'filterConfig.deliveriesSettings.dynamicColumns'), (value, key) => {
      return value;
    })

    this.isScrollable = !this.$mdMedia('gt-md') ||
      _.keys({...availableColumns, ...dynamicColumns}).length >= 11;
  };

  $onDestroy() {
    this._destroyPushesTimer();
  };

  private _initPushesTimer() {
    this._destroyPushesTimer();

    this.pushesTimeoutRef = this.$timeout(() => {

      if (!!this.isStillThereConfirmEnabled) return;

      this.$timeout.cancel(this.pushesTimeoutRef);
      this.pushesTimeoutRef = undefined;

      this.isStillThereConfirmEnabled = true;
      this.commonsDialogService.stillThereConfirm()
        .then((continueSession) => {
          if (continueSession) {
            this.isStillThereConfirmEnabled = false;
            this._initPushesTimer();
          }
        })
    }, (this.maxUserIdleTimeMinutes * 60000));
  }

  private _destroyPushesTimer() {
    if (this.pushesTimeoutRef) {
      this.$timeout.cancel(this.pushesTimeoutRef);
      this.pushesTimeoutRef = undefined;
    }
  }

}

angular
  .module('bringoz.admin.deliveries')
  .component('deliveriesTableView', {
    require: {
      deliveriesViewCtrl: '^deliveriesView'
    },
    bindings: {
      selectedGroup: '<',
      viewTableSettings: '<',
      groupList: '<',
      onChange: '&'
    },
    template: require('./deliveries-table-view.html').default,
    controller: DeliveriesTableViewCtrl
  });
